/** Fonte única das features por tenant (backend e frontend). A chave é `String` no banco (não enum): feature nova não exige migration. */
export const FEATURES = {
  RELATORIO_IA: {
    nome: 'Melhoria de relatório com IA',
    descricao: 'Permite melhorar relatórios de aula com o Gemini.',
  },
} as const;

export type FeatureKey = keyof typeof FEATURES;

export const FEATURE_KEYS = Object.keys(FEATURES) as FeatureKey[];

/** Pura de propósito: roda igual no backend (`assertFeature`) e no client (`AuthProvider.hasFeature`). */
export function hasFeature(features: readonly FeatureKey[], key: FeatureKey): boolean {
  return features.includes(key);
}
